import React, { useEffect, useState } from "react";
import { exchangeSuperUserToken, urlWithoutSuperUserToken } from "../utils/superUserLogin";

const FAILURE_MESSAGE = "The admin session link is invalid or has expired.";

/**
 * Rendered instead of the router while ?super_user_token= is in the URL, so
 * PrivateRoute never sees an unauthenticated visitor. On success the page is
 * reloaded at the same path without the token and opens signed in as the
 * customer; on failure the token is dropped and the normal sign-in takes over.
 */
const SuperUserLoginGate = ({ token }: { token: string }) => {
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    const finish = () => window.location.replace(urlWithoutSuperUserToken());
    const fail = (text: string) => {
      if (cancelled) return;
      setMessage(text);
      setTimeout(finish, 3000);
    };
    exchangeSuperUserToken(token)
      .then((result) => {
        if (cancelled) return;
        if (result.ok) finish();
        else fail(result.message || FAILURE_MESSAGE);
      })
      .catch(() => fail(FAILURE_MESSAGE));
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "inherit",
        color: "#333",
        padding: 24,
        textAlign: "center",
      }}
    >
      <div>
        <p style={{ fontSize: 18, margin: 0 }}>
          {message ? message : "Signing you in as this customer…"}
        </p>
        {message ? <p style={{ fontSize: 14, color: "#777" }}>Taking you to the sign-in page.</p> : null}
      </div>
    </div>
  );
};

export default SuperUserLoginGate;
